import { ComponentProps } from "@declarations/props";
import { Button, Modal } from "antd";
import { FaCheckCircle } from "react-icons/fa";

export const PopupConfirm: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm?: string;
  textCancel: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}> = ({
  open,
  title,
  message,
  textConfirm = "Ya",
  textCancel = "Batalkan",
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        onCancel={onCancel}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1 white-btn"
            style={{ width: "47%" }}
            onClick={onCancel}
          >
            {textCancel}
          </Button>,
          <Button
            key="submit"
            className="tw-mt-4 tw-m-1 tw-text-white bg-gradient"
            style={{ width: "47%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-other-500">{message}</div>
      </Modal>
    </>
  );
};

export const PopupCustom: ComponentProps<{
  open: boolean;
  title: string;

  onCancel?: () => void;
}> = ({ open, title, onCancel = () => {}, children }) => {
  return (
    <>
      <Modal
        className=""
        title={title}
        open={open}
        onCancel={onCancel}
        closable={false}
        footer={null}
        centered
      >
        <div className="tw-text-sm tw-text-other-500">{children}</div>
      </Modal>
    </>
  );
};

export const PopupSuccess: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm: string;
  onConfirm?: () => void;
}> = ({ open, title, message, textConfirm, onConfirm = () => {} }) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1 tw-text-white bg-gradient"
            style={{ width: "100%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-other-500">{message}</div>
      </Modal>
    </>
  );
};

export const PopupError: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm: string;
  onConfirm?: () => void;
}> = ({ open, title, message, textConfirm, onConfirm = () => {} }) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1 tw-text-white bg-gradient"
            style={{ width: "100%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-other-500">{message}</div>
      </Modal>
    </>
  );
};
